import Vue from 'vue';
import Router from 'vue-router';
import nprogress from 'nprogress';

import store from '@/store';

import MainLayout from '@/components/layout/MainLayout.vue';
import { sendMessageToSentry } from '@/utilities/sentry.js';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  base: '/',
  routes: [
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          path: '',
          redirect: '/sign_in',
        },
        {
          path: 'account_no_password',
          name: 'auth/accountNoPassword',
          component: () => import('@/modules/auth/AccountNoPassword.vue'),
        },
      ],
    },
    {
      path: '/sign_up',
      component: MainLayout,
      children: [
        {
          path: '',
          name: 'auth/signUp',
          component: () => import('@/modules/auth/SignUp.vue'),
        },
        {
          path: 'by_phone',
          name: 'auth/signUpByPhone',
          component: () => import('@/modules/auth/SignUpByPhone.vue'),
        },
        {
          path: 'by_email',
          name: 'auth/signUpByEmail',
          component: () => import('@/modules/auth/SignUpByEmail.vue'),
        },
        {
          path: 'verify_email',
          name: 'auth/signUpVerifyEmail',
          component: () => import('@/modules/auth/SignUpVerifyEmail.vue'),
        },
      ],
    },
    {
      path: '/sign_in',
      component: MainLayout,
      children: [
        {
          path: '',
          name: 'auth/signIn',
          component: () => import('@/modules/auth/SignIn.vue'),
        },
        {
          path: 'by_phone',
          name: 'auth/signInByPhone',
          component: () => import('@/modules/auth/SignInByPhone.vue'),
        },
        {
          path: 'by_email',
          name: 'auth/signInByEmail',
          component: () => import('@/modules/auth/SignInByEmail.vue'),
        },
        {
          path: 'by_email_otp',
          name: 'auth/signInByEmailOTP',
          component: () => import('@/modules/auth/SignInByEmailOTP.vue'),
        },
        {
          path: 'with_social_account',
          name: 'auth/signInWithSocialAccount',
          component: () => import('@/modules/auth/SignInWithSocialAccount.vue'),
        },
        {
          path: 'with_passwordless_account',
          name: 'auth/signInWithPasswordlessAccount',
          component: () => import('@/modules/auth/LinkEmailAccount.vue'),
        },
        {
          path: 'account_not_created',
          name: 'auth/signInFailWithSocialAccount',
          component: () => import('@/modules/auth/SignInFailWithSocialAccount.vue'),
        },
        {
          path: 'account_no_password',
          name: 'auth/signInAccountNoPassword',
          component: () => import('@/modules/auth/SignInAccountNoPassword.vue'),
        },
        {
          path: 'verify_email',
          name: 'auth/signInVerifyEmail',
          component: () => import('@/modules/auth/SignInVerifyEmail.vue'),
        },
      ],
    },
    {
      path: '/re_auth',
      component: MainLayout,
      children: [
        {
          path: '',
          name: 'auth/reAuthSignIn',
          component: () => import('@/modules/auth/ReAuthSignIn.vue'),
        },
        {
          path: 'by_phone',
          name: 'auth/reAuthSignInByPhone',
          component: () => import('@/modules/auth/ReAuthSignInByPhone.vue'),
        },
        {
          path: 'by_email',
          name: 'auth/reAuthSignInByEmail',
          component: () => import('@/modules/auth/ReAuthSignInByEmail.vue'),
        },
        {
          path: 'by_email_otp',
          name: 'auth/reAuthSignInByEmailOTP',
          component: () => import('@/modules/auth/ReAuthSignInByEmailOTP.vue'),
        },
        {
          path: 'by_social',
          name: 'auth/reAuthSignInBySocial',
          component: () => import('@/modules/auth/ReAuthSignInBySocial.vue'),
        },
        {
          path: 'verify_email',
          name: 'auth/reAuthSignInVerifyEmail',
          component: () => import('@/modules/auth/SignInVerifyEmail.vue'),
        },
      ],
    },
    {
      path: '/email_verification',
      component: MainLayout,
      children: [
        {
          path: 'expired',
          name: 'auth/emailVerificationExpired',
          component: () => import('@/modules/auth/EmailVerificationExpired.vue'),
        },
        {
          path: 'resent',
          name: 'auth/emailVerificationResent',
          component: () => import('@/modules/auth/EmailVerificationResent.vue'),
        },
        {
          path: 'success',
          name: 'auth/emailVerificationSuccess',
          component: () => import('@/modules/auth/EmailVerificationSuccess.vue'),
        },
      ],
    },
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          path: 'error',
          name: 'error',
          component: () => import('@/modules/error/ErrorPage.vue'),
        },
      ],
    },
    {
      path: '*',
      redirect: '/sign_in',
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (!navigator.userAgent.includes('uiWinMgr')) {
    nprogress.start();
  }

  try {
    store.dispatch('genVisitorId');
  } catch (error) {
    sendMessageToSentry('FingerprintScriptLoadFail', {
      level: 'error',
      extra: [
        {
          name: 'error',
          value: error?.response,
        },
      ],
    });
  }

  next();
});

router.afterEach(async () => {
  nprogress.done();
});

export default router;
